<template>
  <div class="wrap">
    <HeaderTop color="#7adbbf" :link="link">自定义电价</HeaderTop>
    <div class="content" v-if="electrovalence.length > 0">
      <div class="warp" v-for="(item,index) in electrovalence" :key="index">
        <div class="content-wrap">
          <div class="content-one">
            <div class="content-one-text">{{index + 1}}.电价类型:</div>
            <input
              class="content-one-input"
              type="text"
              v-model="item.tpyeName"
              v-if="indexId == index"
            />
            <input
              class="content-one-input"
              type="text"
              v-model="item.tpyeName"
              disabled="disabled"
              v-else
            />
            <img src="../../assets/imgs/mistake.png" class="imgs" @click="deleteGenre(item)" />
          </div>
        </div>
        <div class="content-wrap content-wraps">
          <div class="content-one">
            <div class="content-one-text">电价:</div>
            <input
              class="content-one-input line-input"
              type="txt"
              onkeyup="value=value.replace(/[^0-9]/g,'')"
              v-model="item.priceMoney"
              v-if="indexId == index"
            />
            <input
              class="content-one-input line-input"
              type="text"
              v-model="item.priceMoney"
              disabled="disabled"
              v-else
            />
            <div class="content-one-texts">/度电</div>
            <img
              src="../../assets/imgs/save.png"
              class="save"
              @click="amendGenreTwo(item)"
              v-if="indexId == index"
            />
            <img src="../../assets/imgs/amend.png" v-else @click="amendGenre(item,index)" />
          </div>
        </div>
      </div>
      <div class="warp" v-if="addPrice">
        <div class="content-wrap">
          <div class="content-one">
            <div class="content-one-text">{{numberID}}.电价类型:</div>
            <input class="content-one-input" type="text" v-model="addType" />

            <img src="../../assets/imgs/mistake.png" class="imgs" @click="addDeleteGenre()" />
          </div>
        </div>

        <div class="content-wrap content-wraps">
          <div class="content-one">
            <div class="content-one-text">电价:</div>
            <input
              class="content-one-input line-input"
              type="txt"
              onkeyup="value=value.replace(/[^0-9]/g,'')"
              v-model="addMoney"
            />

            <div class="content-one-texts">/度电</div>
            <img src="../../assets/imgs/save.png" class="save" @click="addGenre()" />
            <!-- <img src="../../assets/imgs/amend.png" @click="amendGenre(item,index)" /> -->
          </div>
        </div>
      </div>
    </div>

    <div class="img-wrap" @click="genres">
      <img src="../../assets/imgs/zdydj.png" alt />
      <div class="img-wrap-text">添加电价类型</div>
    </div>
  </div>
</template>

<script>
import {
  electrovalenceList,
  addElectrovalence,
  amendElectrovalence,
  deleteElectrovalence
} from "../../api";
import { Toast } from "vant";
import HeaderTop from "../../components/HeaderTop.vue";

export default {
  name: "CommonProblems",
  data() {
    return {
      link: "/myWallet",
      electrovalence: [],
      types: "",
      price: "",
      adminId: "",
      isShow: false,
      isOK: false,
      isADD: false,
      indexId: "sss",
      numberID: "",
      addType: "",
      addMoney: "",
      addPrice: false
    };
  },
  components: {
    HeaderTop
  },
  methods: {
    //点击添加点击类型
    genres() {
      // let tpyeName = "";
      // let priceMoney = "";
      // let obj = {};
      // this.electrovalence.push(obj);
      this.isShow = true;
      this.isADD = true;
      this.addPrice = true;
      this.numberID = this.electrovalence.length + 1;
    },
    //点新增按钮的删除
    addDeleteGenre() {
      this.addPrice = false;
    },
    //添加电价类型
    addGenre() {
      let that = this;
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "提示",
        content: "是否添加电价",
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          let adminId = that.adminId;
          let priceMoney = that.addMoney;
          let tpyeName = that.addType;
          addElectrovalence(adminId, priceMoney, tpyeName)
            .then(res => {
              if (res.status == 1) {
                that.isShow = false;
                that.isOK = false;
                that.addPrice = false;
                that.indexId = "ss";
                Toast.success("添加电价成功");
                that.genreList();
              } else {
                Toast.fail(res.msg);
              }
            })
            .catch(err => {});
        },
        onCancel: () => {
          this.$createToast({
            type: "warn",
            time: 1000,
            txt: "点击取消按钮"
          }).show();
        }
      }).show();
    },
    //删除电价类型
    deleteGenre(item) {
      let that = this;
      if (this.isShow) {
        Toast.fail("请您先保存信息！");
        return;
      }
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "提示",
        content: "是否删除电价",
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          let priceTypeId = item.id;
          deleteElectrovalence(priceTypeId)
            .then(res => {
              if (res.code == 0) {
                that.isShow = false;
                Toast.success("删除电价成功");
                that.genreList();
              } else {
                Toast.fail(res.msg);
              }
            })
            .catch(err => {});
        },
        onCancel: () => {
          this.$createToast({
            type: "warn",
            time: 1000,
            txt: "点击取消按钮"
          }).show();
        }
      }).show();
    },
    //确定修改
    amendGenreTwo(item) {
      let that = this;
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "提示",
        content: "是否修改电价",
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          let id = item.id;
          let adminId = that.adminId;
          let priceMoney = item.priceMoney;
          let tpyeName = item.tpyeName;
          amendElectrovalence(id, adminId, priceMoney, tpyeName)
            .then(res => {
              if (res.status == 1) {
                that.isShow = false;
                that.indexId = "SSS";
                Toast.success("修改电价成功");
                that.genreList();
              } else {
                Toast.fail(res.msg);
              }
            })
            .catch(err => {});
        },
        onCancel: () => {
          this.$createToast({
            type: "warn",
            time: 1000,
            txt: "点击取消按钮"
          }).show();
        }
      }).show();
    },
    //修改电价类型
    amendGenre(item, index) {
      let that = this;
      this.isOK = true;
      this.indexId = index;
    },
    //电价列表
    async genreList() {
      let adminId = sessionStorage.getItem("userID");
      let result = await electrovalenceList(adminId);
      if (result.status == 1) {
        this.electrovalence = result.data;
      }
    }
  },
  mounted() {
    this.adminId = sessionStorage.getItem("userID");
    this.genreList();
  }
};
</script>

<style scoped lang="less">
.wrap {
  width: 100%;
  overflow-y: hidden;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  .content {
    box-sizing: border-box;
    margin-top: 0.4rem;
    height: 75%;
    overflow-y: auto;
    .warp {
      border: 0.01rem solid #fff;
      position: relative;
      margin-bottom: 0.2rem;
      .amend {
        position: absolute;
        right: 0.38rem;
        top: 0.55rem;
      }
      .content-wrap {
        width: 90%;
        margin-top: 0.2rem;
        .content-one {
          margin-left: 0.35rem;
          display: flex;
          align-items: center;
          .imgs {
            margin-left: 0.4rem;
          }

          .content-one-text {
            width: 2rem;
            font-size: 0.15rem;
            color: #666;
            text-align: end;
          }
          .content-one-input {
            margin-left: 0.1rem;
            width: 1.35rem;
            height: 0.25rem;
            border: 1px solid #e4e3e4;
            border-radius: 4px;
            font-size: 0.14rem;
          }
          .line-input {
            margin-left: 0.1rem;
            width: 0.8rem;
          }
          .content-one-texts {
            width: 2rem;
            font-size: 0.14rem;
            color: #e0e0e1;
            margin-left: 0.1rem;
          }
        }
      }
      .content-wraps {
        width: 90%;
        margin-top: 0.2rem;
        // margin-left: -0.12rem;
      }
    }
  }
  .img-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    // margin-top: 40%;
    position: absolute;
    bottom: 0.1rem;
    left: 40%;
    img {
      width: 0.7rem;
      height: 0.7rem;
    }
    .img-wrap-text {
      font-size: 0.15rem;
      color: #aeaeaf;
      margin-top: 0.1rem;
    }
  }
}
</style>
